export const generateBundleInitialValues = (bundle) => {
  const { id, selectedOption, options } = bundle;

  const selection = options.find((option) => option.id === selectedOption);

  // TODO: Revisit for better implementation
  return selection
    ? {
        id,
        title: selection.name,
        price: selection?.price?.price?.value,
        value: selection.id,
        products: selection.content
          .filter((product) => product.name !== null && product.included)
          .map((product) =>
            product?.productSpecificTexts?.productSegmentAvailabilityTexts?.length > 0
              ? product
              : product.name,
          ),
        options,
        selectedOption,
      }
    : false;
};

export const generateInitialValuesAncillaryBundles = (bundles = []) => ({
  bundles: bundles.reduce((acc, bundle) => {
    const selectedOption = bundle?.selectedOption;
    if (selectedOption !== null) {
      return [...acc, generateBundleInitialValues(bundle)];
    }
    return [...acc];
  }, []),
});
